<div class="p-grid" *ngIf="isLoading()">
  <div class="p-col">
    <button class="wig-button" (click)="onClick(1)" label="Stats"
      [ngClass]="tabIndex === 1 ? 'wig-button-checked' : 'wig-button'" pButton type="button"></button>
  </div>
  <div class="p-col">
    <button class="wig-button" (click)="onClick(2)" label="Team"
      [ngClass]="tabIndex === 2 ? 'wig-button-checked' : 'wig-button'" pButton type="button"></button>
  </div>
  <div class="p-col" *ngIf="!excludeBonus()">
    <button class="wig-button" (click)="onClick(3)" label="Bonus"
      [ngClass]="tabIndex === 3 ? 'wig-button-checked' : 'wig-button'" pButton type="button"></button>
  </div>
  <div class="p-col">
    <button class="wig-button" (click)="onClick(4)" label="Awards"
      [ngClass]="tabIndex === 4 ? 'wig-button-checked' : 'wig-button'" pButton type="button"></button>
  </div>
</div>
<div *ngIf="tabIndex === 1 && isLoading()">
  <app-wig-stats
  #wigStatsComponent></app-wig-stats>
</div>
<div *ngIf="tabIndex === 2">
  <driver-team-information></driver-team-information>
  <team-competition-chart></team-competition-chart>
</div>
<div *ngIf="tabIndex === 3">
  <app-wig-bonus [optInStatus]="optInStatus"></app-wig-bonus>
</div>
<div *ngIf="tabIndex === 4">
  <app-wig-awards></app-wig-awards>
</div>

<div class="p-grid p-justify-center">
  <cre-spinner [size]="'md'" [hidden]="this.fleet !== undefined"></cre-spinner>
</div>
